import React, { useMemo } from "react";
import type { Objection } from "./types";

interface ObjectionRequestsStatsProps {
  objections: Objection[];
  activeStatus: string;
  onStatusSelect: (status: string) => void;
}

export const ObjectionRequestsStats: React.FC<ObjectionRequestsStatsProps> = ({
  objections,
  activeStatus,
  onStatusSelect,
}) => {
  const stats = useMemo(
    () => ({
      pending: objections.filter((obj) => obj.status === "pending").length,
      approved: objections.filter((obj) => obj.status === "approved").length,
      rejected: objections.filter((obj) => obj.status === "rejected").length,
      total: objections.length,
    }),
    [objections],
  );

  const cards = [
    {
      status: "all",
      value: stats.total,
      label: "Total Requests",
      borderClass: "border-blue-500",
      valueClass: "text-gray-900",
      activeClass: "ring-blue-200",
    },
    {
      status: "pending",
      value: stats.pending,
      label: "Pending Review",
      borderClass: "border-yellow-500",
      valueClass: "text-yellow-700",
      activeClass: "ring-yellow-200",
    },
    {
      status: "approved",
      value: stats.approved,
      label: "Approved",
      borderClass: "border-green-500",
      valueClass: "text-green-700",
      activeClass: "ring-green-200",
    },
    {
      status: "rejected",
      value: stats.rejected,
      label: "Rejected",
      borderClass: "border-red-500",
      valueClass: "text-red-700",
      activeClass: "ring-red-200",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((card) => {
        const isActive = activeStatus === card.status;

        return (
          <button
            key={card.status}
            type="button"
            onClick={() => onStatusSelect(card.status)}
            className={`bg-white p-4 rounded-lg shadow-sm border-l-4 ${card.borderClass} text-left transition hover:shadow-md focus:outline-none focus:ring-2 ${
              isActive ? `ring-2 ${card.activeClass}` : "ring-transparent"
            }`}
          >
            <div className={`text-2xl font-bold ${card.valueClass}`}>
              {card.value}
            </div>
            <div className="text-sm text-gray-600">{card.label}</div>
          </button>
        );
      })}
    </div>
  );
};
